import {
  REQUEST_REJECTED_CLAIMS,
  SET_REJECTED_CLAIMS,
} from 'containers/ManagerRejectedClaimsPage/constants';

export const requestRejectedClaims = (
  status: string,
  page: number,
  pageSize: number,
) => ({
  type: REQUEST_REJECTED_CLAIMS,
  status,
  page,
  pageSize,
});

export const setRejectedClaims = (response: any) => ({
  type: SET_REJECTED_CLAIMS,
  response,
});
